import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { firebaseConfig } from "./Configuration/FirebaseConfiguration";


// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);